import { render, staticRenderFns } from "./PPVPackages.vue?vue&type=template&id=49e8d7dc&scoped=true&"
import script from "./PPVPackages.vue?vue&type=script&lang=js&"
export * from "./PPVPackages.vue?vue&type=script&lang=js&"
import style0 from "./PPVPackages.vue?vue&type=style&index=0&id=49e8d7dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e8d7dc",
  null
  
)

export default component.exports